import React                                        from "react";
import { LocalizationProvider, DesktopDatePicker }  from "@mui/x-date-pickers";
import { AdapterDayjs }                             from "@mui/x-date-pickers/AdapterDayjs";
import dayjs                                        from "dayjs";
import CalendarTodayIcon                            from "@mui/icons-material/CalendarToday";
import "dayjs/locale/it";

function CustomDatePickerAggiungi({ name, label, onChange, values, minDate, disabled }) {
  dayjs.locale("it");

  // const handleChange = (newValue) => {
  //   if (newValue) {
  //     onChange({ [name]: dayjs(newValue).format("DD/MM/YYYY") });
  //   }
  // };
  const handleChange = (newValue) => {
    if (newValue) {
      const date = dayjs(newValue);

      // Validazione manuale dell'anno
      const year = date.year();
      if (year >= 1000 && year <= 9999) {
        const formattedDate = date.format("DD/MM/YYYY");
        onChange({ [name]: formattedDate });
      } else {
        console.error("Anno non valido:", year);
      }
    }
  };

  const handleInput = (event) => {
    const inputValue = event.target.value;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; 

    if (!regex.test(inputValue)) {
      console.warn("Formato data non valido:", inputValue);
    }
  };



  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
      <DesktopDatePicker
        key={disabled ? 'disabled' : values[name] || 'empty'}
        label={label}
        value={values[name] ? dayjs(values[name], "DD/MM/YYYY") : null}
        onChange={handleChange}
        inputFormat="DD/MM/YYYY"
        minDate={minDate ? dayjs(minDate, "DD/MM/YYYY") : dayjs("2018-01-01")}
        maxDate={dayjs()}
        disabled={disabled}
        components={{
          OpenPickerIcon: CalendarTodayIcon, 
        }}
        slotProps={{
          textField: {
            onInput: handleInput,
            sx: {
              width: '100%',
              textAlign: "left",
              backgroundColor: disabled ? "transparent" : "#FFFFFF",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#fda03d",
                },
                "&:hover fieldset": {
                  borderColor: "#fda03d",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#fda03d",
                },
              },
              "& .MuiOutlinedInput-root.Mui-disabled": {
                bgcolor: "transparent",
                cursor: "not-allowed",
              },
              "& .Mui-disabled": {
                cursor: "not-allowed",
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#fda03d",
              },
            },
          },
        }}
      />
    </LocalizationProvider>
  );
}

export default CustomDatePickerAggiungi;
